/* Everest VW product page with builder (Get You Booked, Oct 2026): swipe gallery, thumbnails, image hint,
   lightbox, sticky offsets, and keeping the builder's open step in view below the sticky header. */
(function () {
  'use strict';

  var root = document.querySelector('[data-evp]');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- sticky header offset ----------
  function headerOffset() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  function setSticky() {
    root.style.setProperty('--evp-sticky', (headerOffset() + 16) + 'px');
    var stage = root.querySelector('.evp-gal__stage');
    if (stage) root.style.setProperty('--evp-stage-h', stage.offsetHeight + 'px');
  }
  // The theme header hides on scroll down and returns on scroll up, so follow it.
  var stickyTick = false;
  window.addEventListener('scroll', function () {
    if (stickyTick) return;
    stickyTick = true;
    var upd = function () { root.style.setProperty('--evp-sticky', (headerOffset() + 16) + 'px'); };
    setTimeout(function () { stickyTick = false; upd(); }, 120);
    setTimeout(upd, 500);
  }, { passive: true });

  // ---------- gallery ----------
  var gal = root.querySelector('[data-evp-gal]');
  var track = gal && gal.querySelector('[data-track]');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  var thumbs = gal ? Array.prototype.slice.call(gal.querySelectorAll('[data-go]')) : [];
  var thumbList = gal && gal.querySelector('[data-thumbs]');
  var countEl = gal && gal.querySelector('[data-count]');
  var prevBtn = gal && gal.querySelector('[data-prev]');
  var nextBtn = gal && gal.querySelector('[data-next-img]');
  var zoomBtn = gal && gal.querySelector('[data-zoom]');
  var hint = gal && gal.querySelector('[data-hint]');
  var current = 0;
  var userMoved = false;

  function width() { return track.clientWidth || 1; }
  function goTo(i, smooth) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: i * width(), behavior: smooth === false || reduce ? 'auto' : 'smooth' });
    setCurrent(i);
  }
  function setCurrent(i) {
    if (i === current && countEl && countEl.textContent === String(i + 1)) return;
    current = i;
    if (countEl) countEl.textContent = String(i + 1);
    thumbs.forEach(function (t, n) {
      var on = n === i;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    var active = thumbs[i];
    if (active && thumbList) {
      var li = active.parentElement;
      var vertical = getComputedStyle(thumbList).flexDirection === 'column';
      if (vertical) {
        var top = li.offsetTop - (thumbList.clientHeight - li.offsetHeight) / 2;
        thumbList.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        var left = li.offsetLeft - (thumbList.clientWidth - li.offsetWidth) / 2;
        thumbList.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    if (prevBtn) prevBtn.disabled = i === 0;
    if (nextBtn) nextBtn.disabled = i === slides.length - 1;
    if (zoomBtn) zoomBtn.hidden = !slides[i] || !slides[i].hasAttribute('data-full');
    slides.forEach(function (s, n) {
      if (n === i) return;
      var v = s.querySelector('video');
      if (v && !v.paused) v.pause();
    });
  }
  function hideHint() {
    if (hint && !hint.classList.contains('is-gone')) hint.classList.add('is-gone');
  }

  if (track && slides.length) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / width());
        if (i !== current) setCurrent(i);
        if (userMoved && track.scrollLeft > 4) hideHint();
      });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, function () { userMoved = true; }, { passive: true });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); hideHint(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { userMoved = true; hideHint(); goTo(+t.getAttribute('data-go')); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { userMoved = true; goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { userMoved = true; hideHint(); goTo(current + 1); });
    window.addEventListener('resize', function () { goTo(current, false); setSticky(); });
    setCurrent(0);

    // Image hint: a one-off nudge so people see there are more photos, then the hint fades.
    if (hint && slides.length > 1) {
      var seen = false;
      try { seen = sessionStorage.getItem('evp-nudged') === '1'; } catch (e) {}
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.disconnect();
            if (!seen && !reduce) {
              setTimeout(function () {
                if (userMoved) return;
                track.scrollTo({ left: Math.min(64, width() * 0.18), behavior: 'smooth' });
                setTimeout(function () { if (!userMoved) track.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
              }, 900);
              try { sessionStorage.setItem('evp-nudged', '1'); } catch (e) {}
            }
            setTimeout(hideHint, 6000);
          });
        }, { threshold: 0.6 });
        io.observe(track);
      }
    }
  }

  // ---------- lightbox ----------
  var lb = root.querySelector('[data-lb]');
  var lbTrack = lb && lb.querySelector('[data-lb-track]');
  var lbCount = lb && lb.querySelector('[data-lb-count]');
  var lbTotal = lb && lb.querySelector('[data-lb-total]');
  var full = slides.filter(function (s) { return s.hasAttribute('data-full'); });
  var built = false;
  var lbCurrent = 0;

  function buildLb() {
    if (built || !lbTrack) return;
    lbTrack.innerHTML = full.map(function (s, n) {
      var img = s.querySelector('img');
      var alt = img ? img.getAttribute('alt') || '' : '';
      return '<li><img src="' + s.getAttribute('data-full') + '" alt="' + alt.replace(/"/g, '&quot;') + '" loading="' + (n < 2 ? 'eager' : 'lazy') + '"></li>';
    }).join('');
    if (lbTotal) lbTotal.textContent = String(full.length);
    lbTrack.addEventListener('scroll', function () {
      var i = Math.round(lbTrack.scrollLeft / (lbTrack.clientWidth || 1));
      if (i !== lbCurrent) { lbCurrent = i; if (lbCount) lbCount.textContent = String(i + 1); }
    }, { passive: true });
    built = true;
  }
  function lbGo(i) {
    lbCurrent = Math.max(0, Math.min(full.length - 1, i));
    lbTrack.scrollTo({ left: lbCurrent * lbTrack.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    if (lbCount) lbCount.textContent = String(lbCurrent + 1);
  }
  function openLb(slide) {
    if (!lb || typeof lb.showModal !== 'function' || !full.length) return;
    buildLb();
    var i = Math.max(0, full.indexOf(slide));
    lb.showModal();
    document.documentElement.style.overflow = 'hidden';
    lbTrack.style.scrollBehavior = 'auto';
    lbTrack.scrollLeft = i * lbTrack.clientWidth;
    lbTrack.style.scrollBehavior = '';
    lbCurrent = i;
    if (lbCount) lbCount.textContent = String(i + 1);
  }
  function closeLb() {
    if (lb && lb.open) lb.close();
    document.documentElement.style.overflow = '';
  }
  if (lb) {
    lb.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    lb.querySelector('[data-lb-close]').addEventListener('click', closeLb);
    lb.addEventListener('cancel', function () { document.documentElement.style.overflow = ''; });
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { lbGo(lbCurrent - 1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { lbGo(lbCurrent + 1); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') lbGo(lbCurrent + 1);
      if (e.key === 'ArrowLeft') lbGo(lbCurrent - 1);
    });
  }
  if (zoomBtn) zoomBtn.addEventListener('click', function () { openLb(slides[current]); });
  slides.forEach(function (s) {
    if (!s.hasAttribute('data-full')) return;
    s.addEventListener('click', function () { openLb(s); });
  });

  // ---------- builder: keep the newly opened step in view below the sticky header ----------
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-evb] [data-next], [data-evb] [data-edit]')) return;
    setTimeout(function () {
      var open = root.querySelector('.evb-step.is-open');
      if (!open) return;
      var top = open.getBoundingClientRect().top;
      var off = headerOffset() + 8;
      if (top < off || top > window.innerHeight * 0.7) {
        window.scrollTo({ top: window.scrollY + top - off, behavior: reduce ? 'auto' : 'smooth' });
      }
    }, 30);
  });

  setSticky();
  window.addEventListener('load', setSticky);
})();
